import { Modal, TextField } from '@material-ui/core';
import { DataGrid, GridToolbar } from '@material-ui/data-grid';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { configs, downloadDoc, downloadImage } from '../../../assets/Config';
import '../../../assets/styles/RM.css'
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import DeleteModalPage from '../../includes/DeleteModalPage';
import { useCRMContext } from '../../../services/contexts/CRMContext';
import { useKYCContext } from '../../../services/contexts/KYCContext';
import { Link } from 'react-router-dom';
import { useRMContext } from '../../../services/contexts/RMContext';
import { Autocomplete } from '@material-ui/lab';
import { useBuyOrderContext } from '../../../services/contexts/BuyOrdersContext';

export default function UniqueEntryPage() {

    const { remarkList, setRemarkList, setEditRemarkData, remarkListType, setRemarkListType, getRemarkByRemarkType, customer, setCustomer, page, setPage, setRelationshipManager, relationshipManager } = useCRMContext()
    const { setShowDelete, setShowSuccess, allowedFunc } = useLogin()
    const { setKycRequesterUserDetail, getKYCVerifiedCustomer, kycVerifiedList } = useKYCContext()
    const { adminList } = useRMContext()
    const { editManualPunch, setEditManualPunch } = useBuyOrderContext();

    const history = useHistory()

    const [deleteId, setDeleteId] = useState({})

    const [rowsDisplay, setRowsDisplay] = useState(configs.defaultRowPerPage);

    const columns = [{ field: "id", headerName: "Remark ID", minWidth: 100, flex: 0.5, hide: true, filterable: false },
    {
        field: "cust_name", headerName: "Customer Name", minWidth: 150, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
            return params.row.user ? params.row.user.name : params.row.name
        }, valueGetter: (params) => params.row.user ? params.row.user.name : params.row.name
    },
    {
        field: "cust_id", headerName: "Customer ID", minWidth: 150, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
            return params.row.user ? params.row.user.id : params.row.id
        }, valueGetter: (params) => params.row.user ? params.row.user.id : params.row.id
    },
    {
        field: "mobile", headerName: "Mobile No.", minWidth: 150, flex: 0.4, cellClassName: "break-text", renderCell: (params) => {
            return `${params.row.user ? params.row.user.mobile ? `+${params.row.user.mobile}` : "" : params.row.mobile ? `+${params.row.mobile}` : ""}`
        }, valueGetter: (params) => params.row.user ? params.row.user.mobile : params.row.mobile
    },
    {
        field: "company_name", headerName: "Company Name", minWidth: 110, flex: 0.1, cellClassName: "break-text MuiTableCellEllipsis", renderCell: (params) => {
            return <p className='MuiTableCellEllipsis'>{params.row.company.name}</p>
        }, valueGetter: (params) => params.row.company ? params.row.company.name : ""
    },
    { field: "call_remark", headerName: "Remark", minWidth: 200, flex: 0.5, cellClassName: "break-text" },
    { field: "last_call_date", headerName: "Last Call Date", minWidth: 100, flex: 0.5, cellClassName: "break-text" },
    {
        field: "view", headerName: " ", minWidth: 60, flex: 0.1, cellClassName: "break-text", cellClassName: "text-primary", renderCell: (params) => {
            return <a href="#" className="custom-link text-primary" onClick={(e) => {
                e.preventDefault()
                setEditRemarkData(params.row)
            }}>Add Remark</a>
        }
    },
    {
        field: "rm_name", headerName: "Relationship Manager", minWidth: 150, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
            return params.row.relationship_manager ? params.row.relationship_manager.name : ""
        }, valueGetter: (params) => params.row.relationship_manager ? params.row.relationship_manager.name : ""
    },
    {
        field: "distributor", headerName: "Distributor", minWidth: 200, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
            return params.row && params.row.distributor && params.row.distributor.name ? params.row.distributor.name : ""
        }, valueGetter: (params) => params.row && params.row.distributor && params.row.distributor.name ? params.row.distributor.name : ""
    },
    {
        field: "distributor_email", headerName: "Distributor Email", minWidth: 200, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
            return params.row && params.row.distributor && params.row.distributor.email ? params.row.distributor.email : ""
        }, valueGetter: (params) => params.row && params.row.distributor && params.row.distributor.email ? params.row.distributor.email : ""
    },
    {
        field: "distributor_mobile", headerName: "Distributor Mobile", minWidth: 200, flex: 0.5, cellClassName: "break-text", hide: true, renderCell: (params) => {
            return params.row && params.row.distributor && params.row.distributor.mobile ? `+${params.row.distributor.mobile}` : ""
        }, valueGetter: (params) => params.row && params.row.distributor && params.row.distributor.mobile ? `+${params.row.distributor.mobile}` : ""
    },
    {
        field: "cust_email", headerName: "Customer Email", minWidth: 150, flex: 0.5, cellClassName: "break-text", renderCell: (params) => {
            if (allowedFunc.includes(configs.functionList['user_management:load_user_details'])) {
                return <Link to={`/customerProfile/${params.row.user ? params.row.user.id : params.row.id}`} onClick={() => {
                    setKycRequesterUserDetail(params.row.user ? params.row.user : params.row)
                }}>{params.row.user ? params.row.user.email : params.row.email}</Link>
            } else {
                return params.row.user ? params.row.user.email : params.row.email
            }
        }, valueGetter: (params) => params.row.user ? params.row.user.email : params.row.email
    },

    {
        field: "status", headerName: "KYC Status", minWidth: 100, flex: 0.3, cellClassName: "break-text", renderCell: (params) => {
            return (
                <div onClick={() => {
                    history.push(`/kyc/${params.row.user ? params.row.user.id : params.row.id}`)
                    setKycRequesterUserDetail({ backTo: "/crm" });
                }}>
                    <p>{params.row.user ? params.row.user.status : params.row.status} {params.value !== configs.statusValues.rejected && params.value !== configs.statusValues.verified ? <i className="fas fa-edit mr-2 text-primary curPoint"></i> : null} </p>
                </div>)
        }, valueGetter: (params) => params.row.user ? params.row.user.status : params.row.status, cellClassName: (params) => {
            let clas;
            if ((params.value) === configs.statusValues.rejected) {
                clas = "text-danger"
            }
            else if ((params.value) === configs.statusValues.verified) {
                clas = "text-success"
            }
            else if ((params.value) === configs.statusValues.pending) {
                clas = "text-primary"
            }
            return clas + " text-capitalize break-text"

        }
    },
    {
        field: "cx_segment", headerName: "Cx Segment", minWidth: 110, flex: 0.1, cellClassName: "break-text"
    },
    {
        field: "interested_in", headerName: "Interested in", minWidth: 110, flex: 0.1, cellClassName: "break-text"
    },
    {
        field: "follow_up_date", headerName: "Follow up Date", minWidth: 110, flex: 0.1, cellClassName: "break-text"
    },
    {
        field: "create_order", headerName: " ", minWidth: 60, flex: 0.1, cellClassName: "break-text", cellClassName: "text-primary", renderCell: (params) => {
            return <a href="#" className="custom-link text-primary" onClick={(e) => {
                e.preventDefault()
                setEditManualPunch(params.row)
            }}>Create Order</a>
        }
    },
    ]

    useEffect(() => {
        (async () => {
            try {
                setRemarkList([])
                setEditRemarkData("")
                setCustomer("")
                setRelationshipManager("")

                if (page > configs.startPage) {
                    setPage(configs.startPage)
                } else {
                    getRemarkByRemarkType(remarkListType, true, null)
                }
            } catch (error) {
                console.error(error);
            }
        })()
    }, [remarkListType])

    useEffect(() => {
        (async () => {
            getRemarkByRemarkType(remarkListType, page === configs.startPage ? true : false, null)
        })()
    }, [page])

    useEffect(() => {
        setRemarkListType("latest")
    }, [])

    const handleChange = async (e, value) => {
        try {
            if (!value) {
                setRemarkList([])
                setCustomer("")
                setRelationshipManager("")
            } else {
                if (remarkListType === Object.keys(configs.crm_insights)[2]) {
                    setCustomer(value)
                    await getRemarkByRemarkType(Object.keys(configs.crm_insights)[2], true, null, value, true)
                }
                else {
                    setRelationshipManager(value)
                    await getRemarkByRemarkType(Object.keys(configs.crm_insights)[3], true, null, value)
                }
            }
        } catch (error) {
            console.error(error);

        }
    }

    // role list page ui code
    return (
        <div id="newsListPage" className='d-md-block' style={{ width: "100%" }}>
            <div className="row d-flex align-items-center mt-2 ml-2 mb-1 mr-3">
                <div className="col-lg-4 col-8 m-0 p-0">
                    <p className="h4 text-custom-grey">Remark Management</p>
                    {(remarkListType === "user" || remarkListType === "rm") ?
                        <Autocomplete
                            className="f-12"
                            id="companyIP"
                            value={remarkListType === "user" ? customer : remarkListType === "rm" ? relationshipManager : ""}
                            placeholder="Select User"
                            getOptionLabel={option => option && option.email ? `${option.name} - ${option.email}` : ""}
                            onChange={handleChange}
                            options={remarkListType === "user" ? kycVerifiedList : adminList}
                            renderInput={(params) => <TextField {...params} placeholder="Select User" className="f-12" onChange={remarkListType === "user" ? getKYCVerifiedCustomer : ""} />}
                        />
                        : null}
                </div>
                <div className='col-4 d-flex align-items-center'>
                    <button id="getAllRecordsBtn" className="btn btn-primary" onClick={async (e) => {
                        e.preventDefault()
                        try {
                            document.getElementById("getAllRecordsBtn").classList.toggle("d-none")
                            document.getElementById("getAllRecordsBtnLoader").classList.toggle("d-none")
                            await getRemarkByRemarkType(remarkListType, true, 0)
                        } finally {
                            const btn = document.getElementById("getAllRecordsBtn")
                            if (btn && btn.classList.contains("d-none")) {
                                btn.classList.toggle("d-none")
                                document.getElementById("getAllRecordsBtnLoader").classList.toggle("d-none")
                            }
                        }
                    }}>Get All Records</button>
                    <div id="getAllRecordsBtnLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                </div>
                <div className="col-4 text-right m-0 p-0">
                    <select className='' id="selectRemarkData" value={remarkListType} onChange={(e) => {
                        e.preventDefault()
                        setRemarkListType(e.target.value)
                    }}>
                        {Object.keys(configs.crm_insights).map((item, index) => {
                            return <option key={index} value={item}>{configs.crm_insights[item]}</option>
                        }
                            // <option value="all">All Remarks</option>
                            // <option value="latest">Latest Remark</option>
                            // <option value="user">User specific remark</option>
                            // <option value="rm">RM specific remark</option>
                            // <option value="none">No RM user</option>
                        )}
                    </select>
                </div>
            </div>
            <div className='row m-0 mx-3 p-0 d-md-none d-block'>
                <a href='#' className='custom-link' onClick={(e) => {
                    e.preventDefault()
                    document.getElementById("rmCreateNews").classList.toggle('d-none')
                    document.getElementById("newsListPage").classList.toggle('d-none')
                }}><p className='m-0 p-0'>Add New Remark</p></a>
            </div>
            {remarkList ?

                <div className="nm-role-table m-2">
                    <DataGrid
                        rows={remarkList}
                        headerHeight={30}
                        rowHeight={40}
                        columns={columns}
                        resizable={true}
                        pageSize={rowsDisplay}
                        pagination
                        components={{
                            Toolbar: GridToolbar,
                        }}
                        onPageChange={(currenIndex) => {
                            if ((currenIndex + 1) === Math.ceil(remarkList.length / rowsDisplay)) {
                                setPage(page + 1);
                            }
                        }}
                        onPageSizeChange={(rowsBeingDisplayed) => {
                            setRowsDisplay(rowsBeingDisplayed);
                        }}

                    // onSelectionModelChange={onRowSelected}
                    />
                </div>
                : <div className="loader"></div>}
            <DeleteModalPage {...deleteId} />

        </div>
    )
}

